var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Avatar, Box, Button, IconButton, Menu, Stack, Tooltip, Typography, } from '@mui/material';
import { IconHomeStar, IconMail, IconSettings } from '@tabler/icons-react';
import ProfileImg from '../../../../assets/images/profile/default-avatar.png';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import { logout } from '../../../../lib/allauth/allauth';
import { states } from '../../../../components/shared/stateList';
import { useDispatch, useSelector } from "react-redux";
import { clearUserProfile, fetchUserProfile } from "../../../../components/store/session/SessionSlice";
import { appUrls } from "../../../../urls";
import SubscriptionBadge from '../../shared/SubscriptionBadge';
var StyledBadge = styled(Badge)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiBadge-badge': {
            backgroundColor: '#44b700',
            color: '#44b700',
            boxShadow: "0 0 0 2px ".concat(theme.palette.background.paper),
            '&::after': {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                animation: 'ripple 1.2s infinite ease-in-out',
                border: '1px solid currentColor',
                content: '""',
            },
        },
        '@keyframes ripple': {
            '0%': {
                transform: 'scale(.8)',
                opacity: 1,
            },
            '100%': {
                transform: 'scale(2.4)',
                opacity: 0,
            },
        },
    });
});
var SmallAvatar = styled(Avatar)(function (_a) {
    var theme = _a.theme;
    return ({
        width: 22,
        height: 22,
        border: "2px solid ".concat(theme.palette.background.paper),
    });
});
var Profile = function (_a) {
    var includeDashboardLink = _a.includeDashboardLink;
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return state.session; }), user = _b.user, loading = _b.loading, profileFetched = _b.profileFetched;
    var _c = useState(null), anchorEl2 = _c[0], setAnchorEl2 = _c[1];
    var _d = useState({
        fetching: false,
        content: null
    }), logoutStatus = _d[0], setLogoutStatus = _d[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!profileFetched) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dispatch(fetchUserProfile()).unwrap()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to fetch user profile:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [dispatch, profileFetched]);
    // Convert the shortened state code to the full name using the states list
    var getFullStateName = function (shortenedState) {
        var state = states.find(function (state) { return state.value === shortenedState; });
        return state ? state.label : 'Unknown State'; // Return the full name or fallback to "Unknown State"
    };
    var handleClick2 = function (event) {
        setAnchorEl2(event.currentTarget);
    };
    var handleClose2 = function () {
        setAnchorEl2(null);
    };
    var triggerLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLogoutStatus(__assign(__assign({}, logoutStatus), { fetching: true }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, logout()];
                case 2:
                    _a.sent();
                    dispatch(clearUserProfile());
                    setLogoutStatus(function (prev) { return (__assign(__assign({}, prev), { content: true })); });
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    window.alert(error_2);
                    setLogoutStatus(function (prev) { return (__assign(__assign({}, prev), { content: null })); }); // Reset on error if needed
                    return [3 /*break*/, 5];
                case 4:
                    setLogoutStatus(function (prev) { return (__assign(__assign({}, prev), { fetching: false })); });
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (logoutStatus.content) {
        return _jsx(Navigate, { to: "/" });
    }
    return (_jsxs(Box, { children: [_jsx(IconButton, __assign({ size: "large", "aria-label": "show 11 new notifications", color: "inherit", "aria-controls": "msgs-menu", "aria-haspopup": "true", sx: __assign({}, (typeof anchorEl2 === 'object' && {
                    color: 'primary.main',
                })), onClick: handleClick2 }, { children: _jsx(Avatar, { src: ProfileImg, alt: "Profile Avatar", sx: {
                        width: 35,
                        height: 35,
                    } }) })), _jsxs(Menu, __assign({ id: "msgs-menu", anchorEl: anchorEl2, keepMounted: true, open: Boolean(anchorEl2), onClose: handleClose2, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, transformOrigin: { horizontal: 'right', vertical: 'top' }, sx: {
                    '& .MuiMenu-paper': {
                        width: '360px',
                        p: 4,
                    },
                } }, { children: [_jsxs(Typography, __assign({ variant: "h5" }, { children: ["My Profile", _jsx(IconButton, __assign({ sx: {
                                    marginTop: '6px',
                                    marginLeft: '6px',
                                    position: 'absolute',
                                    padding: 0,
                                }, component: "a", href: "/user/account-settings" }, { children: _jsx(IconSettings, { size: 16 }) })), _jsx(SubscriptionBadge, {})] })), _jsxs(Stack, __assign({ direction: "row", py: 3, spacing: 2, alignItems: "center" }, { children: [_jsx(StyledBadge, __assign({ overlap: "circular", anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, variant: "dot" }, { children: _jsx(Avatar, { src: ProfileImg, alt: "Profile", sx: { width: 95, height: 95 } }) })), _jsxs(Box, { children: [user.firstName && user.lastName ? (_jsxs(Typography, __assign({ variant: "subtitle2", color: "textPrimary", fontWeight: 600 }, { children: [user.firstName, " ", user.lastName] }))) : (_jsx(Typography, __assign({ variant: "subtitle2", color: "textPrimary", fontWeight: 600 }, { children: user.firstName || user.lastName || "" }))), _jsx(Typography, __assign({ variant: "subtitle2", color: "textSecondary", display: "flex", alignItems: "center", gap: 1 }, { children: _jsx(Tooltip, __assign({ title: "My Email" }, { children: _jsxs(_Fragment, { children: [_jsx(IconMail, { style: { marginTop: '3px' }, width: 15, height: 15 }), loading ? "Loading..." : (user.email || "No email provided")] }) })) })), user.homeState && (_jsx(Typography, __assign({ variant: "subtitle2", color: "textSecondary", display: "flex", alignItems: "center", gap: 1 }, { children: _jsx(Tooltip, __assign({ title: "My Home State" }, { children: _jsxs(_Fragment, { children: [_jsx(IconHomeStar, { width: 15, height: 15 }), getFullStateName(user.homeState)] }) })) })))] })] })), _jsxs(Stack, __assign({ spacing: 1 }, { children: [includeDashboardLink && _jsx(Button, __assign({ variant: "contained", color: "primary", component: Link, to: appUrls.user.DASHBOARD }, { children: 'Dashboard' })), _jsx(Button, __assign({ variant: "outlined", color: "primary", disabled: logoutStatus.fetching, onClick: triggerLogout, fullWidth: true }, { children: logoutStatus.fetching ? 'Logging out...' : 'Logout' }))] }))] }))] }));
};
export default Profile;
